import React from 'react';
import PropTypes from "prop-types";
import './Div.less';

const Div = (props) => {
    return (
        <div className={'Div' + (props.className == null ? '' : ' ' + props.className)}>
            {props.children}
        </div>
    );
}

Div.propTypes = {
    className: PropTypes.string,
};
Div.defaultProps = {}

export default Div;